/* ======== Types ========= */
import type { Distribution } from "@memorang/types/src/content";
import Box from "@memorang/ui/src/components/Box";
import Container from "@memorang/ui/src/components/Container";
import type { Stat } from "@memorang/ui/src/components/RowStats";
/* ======== Components ========= */
import ContentHero from "@memorang/ui/src/components/StudyPackApplet/ContentHero";
import TagsSectionList, {
	type SectionTag,
} from "@memorang/ui/src/components/StudyPackApplet/TagsSectionList";
import type {
	FontSchemaType,
	QuickActionsChipType,
} from "@memorang/ui/src/types";
import { useDevice } from "@memorang/ui/src/useDevice";
import { FlatList } from "react-native";

interface Props {
	distribution: Distribution;
	productTitle: string;
	productImage: string;
	stats?: Stat[];
	sectionTags: SectionTag[];
	handleNavigateToIAP: () => void;
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
	actionChips: QuickActionsChipType[];
	handleClickListItem: (selectedTagId: number, locked?: boolean) => void;
	appFont?: FontSchemaType;
}
const StudyPackView = ({
	distribution,
	productTitle,
	productImage,
	stats,
	sectionTags,
	handleNavigateToIAP,
	handleQuickActionPress,
	actionChips,
	handleClickListItem,
	appFont,
}: Props) => {
	const { isMobile } = useDevice();

	return (
		<Box flex={1}>
			<Container>
				<FlatList
					data={[]}
					keyExtractor={(item) => item}
					renderItem={() => <></>}
					ListHeaderComponent={
						isMobile ? (
							<ContentHero
								distribution={distribution}
								title={productTitle}
								stats={stats}
								image={productImage}
								handleQuickActionPress={handleQuickActionPress}
								actionChips={actionChips}
							/>
						) : null
					}
					ListFooterComponent={
						<TagsSectionList
							handleNavigateToIAP={handleNavigateToIAP}
							sectionTags={sectionTags}
							handleClickListItem={handleClickListItem}
							appFont={appFont}
						/>
					}
				/>
			</Container>
		</Box>
	);
};
export default StudyPackView;
